import { useParams } from 'react-router-dom'

import { RoleLevelDetailsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import JobLevelEmployeesDataCollection from 'modules/project_management/components/tables/JobLevelEmployeesDataCollection'

const RoleDetailsPage = () => {
  const { jobLevelId } = useParams()

  const { data, loading, error } = useQuery(RoleLevelDetailsPageDocument, {
    variables: {
      resourceId: Number(jobLevelId),
    },
  })

  const canSeeJobsAndRatesPage = !!data?.projectManagement._policies.pagesSeeJobsAndRates.can
  const rateId = data?.projectManagement.ratesConnection.nodes.at(-1)?.id

  return (
    <ResponsivePage.Body
      variant="wide"
      loading={!data && loading}
      error={error}
      authorized={canSeeJobsAndRatesPage}
    >
      <JobLevelEmployeesDataCollection referenceRateId={Number(rateId)} />
    </ResponsivePage.Body>
  )
}

export default RoleDetailsPage
